type UserDetailsArgs = {
  childId: string | null;
  childHex: string | null;
};

export const usersKeys = {
  all: ["users"] as const,
  details: () => [...usersKeys.all, "detail"] as const,
  detail: (user: UserDetailsArgs) => [...usersKeys.details(), user] as const
};
